import { IndexChatComponentMainDiv } from "../../styles/indexcomponentsstyles/indexchatcomponentstyles";
import { ReactComponent as Icon } from "./assets/brain-solid-full.svg";
import Logo from"./assets/bugzi logo 2.png"
const IndexChatComponent = () => {
  return (
    <>
      <IndexChatComponentMainDiv>
        <div>
          <div className="index-chat-human-chat-holder">
            <div>
              <div>
                <div className="index-chat-human-chat-image-holder-invinsible"></div>
              </div>
              <div className="index-chat-chatbox-contain">
                <div>
                  <div className="index-chat-human-chat-text-holder">
                    <p>
                      Could not read source map for
                      
                    </p>
                  </div>
                </div>
              </div>
              <div>
                <div className="index-chat-human-chat-image-holder"></div>
              </div>
            </div>
          </div>
          <div className="index-chat-human-chat-holder-reverse">
            <div>
              <div>
                <div className="index-chat-human-chat-image-holder-invinsible" />
              </div>
              <div className="index-chat-chatbox-contain">
                <div className="index-chat-chatbox-action-container">
                  <div className="index-chat-human-chat-text-holder">
                    <h3>Could not read source map for</h3>
                  </div>
                  <div className="index-chat-human-chat-action-holder">
                    <div>
                      <div className="index-chat-icon">
                        <Icon />
                      </div>
                      <div className="file-name">
                        <div>
                          <p> file name </p>
                        </div>
                      </div>
                      <div className="index-chat-checkbox">
                        <Icon />
                      </div>
                    </div>
                  </div>
                  <div className="index-chat-human-chat-text-holder">
                    <p>
                      Could not read source map for
                      
                    </p>
                  </div>
                </div>
              </div>
              <div>
                <div className="index-chat-human-chat-image-holder">
                    <img src={Logo} alt="bugzi logo"></img>
                </div>
              </div>
            </div>
          </div>
        </div>
      </IndexChatComponentMainDiv>
    </>
  );
};
export default IndexChatComponent;
